module.exports = __webpack_public_path__ + "static/media/google_play.54d6bd78.svg";